module.exports = __webpack_public_path__ + "img/fluid.484a0891.jpeg";